import contractReducer from './contractReducer'
import usageReducer from './usageReducer'
import { combineReducers } from 'redux'

export default combineReducers({
  contract: contractReducer,
  usage: usageReducer
})
